import createAction from 'loankeeper-common/helpers/createAction'

import { actions } from './constants'

export const getFields = (args, resolve) => createAction(actions.FETCH, args, { resolve })
export const fieldsFetched = (fields) => createAction(actions.FETCH_SUCCESS, { fields })
export const fetchFailed = (error) => createAction(actions.FETCH_FAILURE, { error })

export const rulesFetched = (rules) => createAction(actions.FETCH_RULES_SUCCESS, { rules })
export const rulesFetchFailed = (error) => createAction(actions.FETCH_RULES_FAILURE, { error })

export const submit = (data, meta) => createAction(actions.SUBMIT, data, meta)
export const submitFaield = (error) => createAction(actions.SUBMIT_FAIL, { error })

export const close = () => createAction(actions.CLOSE)
